import {
  ACADEMY_PAGE_ROUTE,
  PLAYLIST_PAGE_ROUTE,
  RootRoute,
  TRENDS_ROUTE,
  VIDEO_PAGE_ROUTE,
  WEBINAR_PAGE_ROUTE,
} from "../../AppConstants/Routes";

export const NAV_LINKS = [
  {
    name: "Home",
    url: RootRoute,
    showTag: false
  },
  {
    name: "Videos",
    url: VIDEO_PAGE_ROUTE,
    showTag: false
  },
  {
    name: "Academy",
    url: ACADEMY_PAGE_ROUTE,
    showTag: false
  },
  {
    name: "Webinar",
    url: WEBINAR_PAGE_ROUTE,
    showTag: false
  },
  {
    name: "Trends",
    url: TRENDS_ROUTE,
    showTag: "New"
  },
  {
    name: "",
    url: "",
    showTag: false
  },
  // {
  //   name: "Resources",
  //   url: "",
  // showTag: false
  // },
  // {
  //   name: "NEWS & Updates",
  //   url: "",
  // showTag: false
  // },
];
